import { render, staticRenderFns } from "./FavoriteExhibitorSender.vue?vue&type=template&id=3ba2b871&"
import script from "./FavoriteExhibitorSender.vue?vue&type=script&lang=js&"
export * from "./FavoriteExhibitorSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports